import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { shortLocaleStringFromDate } from "@/helpers/datehelper";
import { profileFromUid } from "@/helpers/requestHelpers/publicDataRequests";
import DialogCard from "@/components/DialogCard.vue";
import { ref, onMounted, watch } from "vue";

import {
  ManagedPatient,
  ManagedPatientDataPoint,
} from "@/interfaces/managedPatient";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import ChangelogEntry from "@/components/ChangelogEntry.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import PatientFile from "./PatientFile.vue";

interface ChangeFileRecord {
  deleted: boolean;
  entry?: ManagedPatientDataPoint;
  date: Date;
  by: string;
  id: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FileHistory',
  props: {
    managedPatient: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const history = ref<ChangeFileRecord[] | null>(null);

watch(
  () => props.managedPatient,
  () => {
    changelog();
  }
);

onMounted(() => {
  changelog();

  window._paq.push(["trackEvent", "FileHistory", "opened", undefined]);
});

async function changelog() {
  history.value = null;
  if (props.managedPatient == null) {
    return;
  }
  const files = props.managedPatient.history.filter((h) => h.type == 3);
  const deletions = await useManagedPatientsStore().loadFileDeletions(
    props.managedPatient.id
  );
  const changes: ChangeFileRecord[] = [];

  for (let file of files) {
    changes.push({
      deleted: false,
      entry: file,
      date: new Date(file.created_at),
      by: file.created_by,
      id: file.id,
    });
  }
  for (let deletion of deletions) {
    changes.push({
      deleted: true,
      date: new Date(deletion.created_at),
      by: deletion.deleted_by,
      id: deletion.data_id,
    });
  }

  history.value = changes.sort((a, b) => b.date.getTime() - a.date.getTime());
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogCard, {
    "show-footer": false,
    title: "Änderungsverlauf - Dateien",
    "is-visible": props.managedPatient != null,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
  }, {
    default: _withCtx(() => [
      (history.value == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : (history.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Keine Einträge"))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(history.value, (change) => {
              return (_openBlock(), _createBlock(ChangelogEntry, {
                key: `${change.id}`,
                "change-by": _unref(profileFromUid)(change.by) ?? null,
                "change-text": null,
                "change-time": _unref(shortLocaleStringFromDate)(change.date)
              }, {
                custom: _withCtx(() => [
                  (change.deleted)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Datei gelöscht"))
                    : _createCommentVNode("", true),
                  (change.entry && _ctx.managedPatient)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createTextVNode(" Datei hochgeladen: "),
                        _hoisted_5,
                        (change.entry && _ctx.managedPatient)
                          ? (_openBlock(), _createBlock(PatientFile, {
                              key: 0,
                              file: change.entry,
                              small: false,
                              patient: _ctx.managedPatient,
                              "allow-delete": false
                            }, null, 8, ["file", "patient"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["change-by", "change-time"]))
            }), 128))
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})